// When the page is restored from the back/forward cache (e.g. the customer hits
// "back" from checkout), the ATC button comes back exactly as it was left — with
// the loading spinner we intentionally keep running until the checkout redirect.
// Reset it so the button is usable again.
window.addEventListener('pageshow', function () {
  document.querySelectorAll('#byteex-submit-button, #byteex-stycky-atc-button').forEach(function (btn) {
    btn.classList.remove('loading');
    btn.disabled = false;
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const updateSlotMachine = (container, count) => {
    if (!container) return;
    const strip = container.querySelector('.color-item-count-strip');
    if (strip) strip.style.transform = `translateY(-${count * 26}px)`;
  };

  const updateSelectedSlotsForCard = (card, newUrl) => {
    const cardId = card.dataset.id;
    if (!cardId) return;

    // Find every selected slot that holds this color and update its image
    document.querySelectorAll('.nail-picker-selected-color[data-id="' + cardId + '"]').forEach(slot => {
      const img = slot.querySelector('img');
      if (img && img.getAttribute('src') !== newUrl) {
        img.setAttribute('src', newUrl);
      }
    });

    // Also update the sticky ATC slots and color-list slots (they mirror the same state)
    const selectedColors = document.querySelectorAll('.nail-picker-selected-color');
    selectedColors.forEach((slot, idx) => {
      if (slot.dataset.id !== cardId) return;

      const stickyAtcSlot = document.querySelectorAll('.byteex-stycky-atc-selected-color')[idx];
      if (stickyAtcSlot) {
        const stickyImg = stickyAtcSlot.querySelector('img');
        if (stickyImg && stickyImg.getAttribute('src') !== newUrl) {
          stickyImg.setAttribute('src', newUrl);
        }
      }

      const colorListSlot = document.querySelectorAll('.color-list-selected-color')[idx];
      if (colorListSlot) {
        const listImg = colorListSlot.querySelector('img');
        if (listImg && listImg.getAttribute('src') !== newUrl) {
          listImg.setAttribute('src', newUrl);
        }
      }
    });
  };

  // Tracks "bundle full" transition so flip only fires on the last-slot-filled moment
  let atcPreviouslyFull = false;

  const playAtcFlip = (fromEl, toEl) => {
    if (!fromEl || !toEl) return;

    // CHOOSE YOUR COLORS rolls up and out the top
    fromEl.classList.remove('rolling-in', 'rolling-out-up', 'rolling-in-from-top', 'rolling-out-down');
    void fromEl.offsetWidth;
    fromEl.classList.add('rolling-out-up');

    // Once it's gone, ADD TO CART rolls up from below
    setTimeout(() => {
      fromEl.style.display = 'none';
      fromEl.classList.remove('rolling-out-up');

      toEl.classList.remove('rolling-in', 'rolling-in-from-top');
      toEl.style.display = 'flex';
      void toEl.offsetWidth;
      toEl.classList.add('rolling-in');

      setTimeout(() => {
        toEl.classList.remove('rolling-in');
      }, 650);
    }, 400);
  };

  const playAtcFlipReverse = (fromEl, toEl) => {
    if (!fromEl || !toEl) return;

    // ADD TO CART rolls down out the bottom
    fromEl.classList.remove('rolling-in', 'rolling-out-down', 'rolling-in-from-top');
    void fromEl.offsetWidth;
    fromEl.classList.add('rolling-out-down');

    // Then CHOOSE YOUR COLORS drops in from the top
    setTimeout(() => {
      fromEl.style.display = 'none';
      fromEl.classList.remove('rolling-out-down');

      toEl.classList.remove('rolling-in', 'rolling-in-from-top');
      toEl.style.display = 'flex';
      void toEl.offsetWidth;
      toEl.classList.add('rolling-in-from-top');

      setTimeout(() => {
        toEl.classList.remove('rolling-in-from-top');
      }, 650);
    }, 400);
  };

  const setAtcButtonState = (isFull) => {
    const chooseEl = document.getElementById('choose-color-button-text');
    const atcEl    = document.getElementById('atc-button-text');
    if (!chooseEl || !atcEl) return;

    if (isFull === atcPreviouslyFull) return;
    atcPreviouslyFull = isFull;

    if (isFull) {
      playAtcFlip(chooseEl, atcEl);
    } else {
      playAtcFlipReverse(atcEl, chooseEl);
    }
  };

    // Overlay resolution — scroll-driven, piggybacks on thumbnail load
  const resolveOverlayForCard = (el) => {
    if (el.dataset.overlayResolved === 'true') return;
    el.dataset.overlayResolved = 'true';

    // Resolve the selected-slot / line-item image straight to the real, always-present
    // per-colour image (featured_image, from the custom.variant_images metafield).
    // Previously this probed a cascade of guessed Shopify Files URLs (nail-<colour>.jpg,
    // -gel-wrap.jpg, capitalised variants…) via new Image(); colours without such a file
    // made every miss log a 404. The guessed data-image-added* attributes are left on the
    // element (harmless — they issue no request unless used as an <img> src).
    const resolved = el.dataset.image || el.dataset.imageLineItem || '';
    el.dataset.imageAdded = resolved;
    el.dataset.imageAddedAlt = '';
    updateSelectedSlotsForCard(el, resolved);
  };

  document.querySelectorAll('.nail-picker-color').forEach(el => {
    const thumbImg = el.querySelector('img');
    if (!thumbImg) return;

    if (thumbImg.complete && thumbImg.naturalHeight > 0) {
      resolveOverlayForCard(el);
    } else {
      thumbImg.addEventListener('load', () => resolveOverlayForCard(el), { once: true });
    }
  });

  // GUARANTEE POPUP BLOCK
  const guarantee_popup_block_open_button = document.getElementById('block-guarantee-popup-open-button');
  const guarantee_popup_block_wrapper = document.getElementById('block-guarantee-popup-wrapper');
  const guarantee_popup_block_close_button = document.getElementById('block-guarantee-popup-close-button');

  if (guarantee_popup_block_open_button && guarantee_popup_block_wrapper) {
    guarantee_popup_block_open_button.addEventListener('click', () => {
      guarantee_popup_block_wrapper.classList.remove('hidden');
    });
  }

  if (guarantee_popup_block_close_button && guarantee_popup_block_wrapper) {
    guarantee_popup_block_close_button.addEventListener('click', () => {
      guarantee_popup_block_wrapper.classList.add('hidden');
    });
  }

  (function () {
    const el = document.querySelector('.color-list-slider-wrapper');
    if (!el) return;

    const bar = document.querySelector('.color-list-scrollbar');
    const track = bar.querySelector('.track');
    const thumb = bar.querySelector('.thumb');

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let rafId = 0;
    let momentumRunning = false;

    const stopMomentum = () => {
      momentumRunning = false;
      cancelAnimationFrame(rafId);
    };

    const momentum = () => {
      momentumRunning = true;
      
      if (Math.abs(velocity) < 0.01) {
        momentumRunning = false;
        return;
      }
      el.scrollLeft -= velocity * 12;
      velocity *= 0.95;
      
      updateThumb();
      rafId = requestAnimationFrame(momentum);
    };

    el.addEventListener('dragstart', (e) => e.preventDefault());

    el.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      isDown = true;
      el.classList.add('grabbing');

      bar.classList.add('active');

      startX = e.clientX;
      startScrollLeft = el.scrollLeft;
      velocity = 0;
      lastX = e.clientX;
      lastTime = Date.now();
      stopMomentum();
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const dx = e.clientX - startX;
      el.scrollLeft = startScrollLeft - dx;

      const now = Date.now();
      const dt = now - lastTime;
      if (dt > 0) velocity = (e.clientX - lastX) / dt;
      lastX = e.clientX;
      lastTime = now;

      updateThumb();
    }, { passive: false });

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('grabbing');

      setTimeout(() => bar.classList.remove('active'), 120);

      if (Math.abs(velocity) > 0.08) momentum();
    };

    window.addEventListener('mouseup', endDrag);
    el.addEventListener('mouseleave', endDrag);

    function updateThumb() {
      const cw = el.clientWidth;
      const sw = el.scrollWidth;
      const sl = el.scrollLeft;

      if (sw <= cw) {
        thumb.style.width = '0px';
        thumb.style.transform = 'translateX(0)';
        return;
      }

      const trackW = track.clientWidth;
      const minThumb = 40;
      const thumbW = Math.max((cw / sw) * trackW, minThumb);
      const maxLeft = trackW - thumbW;
      const left = (sl / (sw - cw)) * maxLeft;

      thumb.style.width = thumbW + 'px';
      thumb.style.transform = `translateX(${left}px)`;
    }

    function syncBarWidth() {
      updateThumb();
    }

    el.addEventListener('scroll', () => {
      updateThumb();
    }, { passive: true });

    window.addEventListener('resize', syncBarWidth);

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => syncBarWidth());
      ro.observe(el);
      ro.observe(track);
    } else {
      setTimeout(syncBarWidth, 60);
    }

    syncBarWidth();
    setTimeout(syncBarWidth, 250);
    setTimeout(syncBarWidth, 500);
    setTimeout(syncBarWidth, 1000);

    const sliderImages = el.querySelectorAll('img');
    let loaded = 0;
    sliderImages.forEach(img => {
      if (img.complete) {
        loaded++;
        if (loaded === sliderImages.length) syncBarWidth();
      } else {
        img.addEventListener('load', () => {
          loaded++;
          if (loaded === sliderImages.length) syncBarWidth();
        }, { once: true });
      }
    });

  })();

  // VARIABLES
  const sectionWrapper = document.getElementById('section-wrapper');
  const addToCartText = sectionWrapper.dataset.addToCartText;
  const chooseColorText = sectionWrapper.dataset.chooseColorText; 
  const placeholder_color_name = sectionWrapper.dataset.placeholderColorName;
  
  // KEENSLIDER
  /*function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active")
        })
      }
      
      function addActive(idx) {
        slider.slides[idx].classList.add("active")
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx)
          })
        })
      }

      slider.on("created", () => {
        addActive(slider.track.details.rel)
        addClickEvents()
        main.on("animationStarted", (main) => {
          removeActive()
          const next = main.animator.targetIdx || 0
          addActive(main.track.absToRel(next))
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
        })
      })
    };
  }*/

  function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active");
        });
      }

      function addActive(idx) {
        slider.slides[idx].classList.add("active");
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx);
          });
        });
      }

      const leftButton = document.getElementById("keen-large-slider-left");
      const rightButton = document.getElementById("keen-large-slider-right");

      rightButton.addEventListener("click", () => {
        if (!slider.track.details.atEnd) {
          main.next();
        }
      });

      leftButton.addEventListener("click", () => {
        if (!slider.track.details.atStart) {
          main.prev();
        }
      });

      slider.on("created", () => {
        addActive(slider.track.details.rel);
        addClickEvents();
        main.on("animationStarted", (main) => {
          removeActive();
          const next = main.animator.targetIdx || 0;
          addActive(main.track.absToRel(next));
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
        });
      });
    };
  }
  
  const product_slider_slides = sectionWrapper.querySelectorAll(".keen-slider__slide");
  product_slider_slides.forEach((slide) => {
    slide.classList.remove("hidden", "mr-[10px]");
  });

  const product_large_slider = new KeenSlider(
    "#product-keen-large-slider", 
    {
      loop: false,
      slides: {
        spacing: 8,
        perView: 1,
      },
    }
  );

  requestAnimationFrame(() => {
    product_large_slider.update();
  });

  const product_thumbnails_slider = new KeenSlider(
    "#product-keen-thumbnail-slider",
    {
        loop: false,
        slides: {
          spacing: 10,
          perView: 6,
        },
        vertical: false,
    },
    [ThumbnailPlugin(product_large_slider)]
  );

  // CUSTOM STICKY ATC BUTTON
  const stickyButtonWrapper = document.querySelector('.byteex-stycky-atc-button-wrapper');
  const stickyButton = document.getElementById('byteex-stycky-atc-button');
  const stickyButtonText = document.getElementById('sticky_atc_button_text');
  const nail_picker = document.getElementById('nail_picker');  
  const productForm = document.querySelector('form[action$="/cart/add"]');
  const submitButton = productForm?.querySelector('button');

  if (stickyButtonWrapper && stickyButtonText && productForm && submitButton) {
    // NOTE: sticky visibility + click-to-scroll are owned by the section's inline
    // "Sticky ATC Bar" controller (IntersectionObserver + .is-active class).
    // Here we only keep the sticky label matching the main button ("CLAIM OFFER").
    const setStickyLabel = () => { stickyButtonText.innerText = 'CLAIM OFFER'; };
    setStickyLabel();
    const buttonObserver = new MutationObserver(setStickyLabel);
    buttonObserver.observe(submitButton, { attributes: true });
  }

  // TWO VIDEO BLOCK
  const two_video_block_button_1 = document.getElementById('two-video-block-button-1');
  const two_video_block_button_2 = document.getElementById('two-video-block-button-2');
  const two_video_block_video_1 = document.getElementById('two-video-block-video-1');
  const two_video_block_video_2 = document.getElementById('two-video-block-video-2');

  if (two_video_block_button_1 && two_video_block_button_2 && two_video_block_video_1 && two_video_block_video_2) {
    two_video_block_button_1.addEventListener('click', () => {
      two_video_block_video_1.classList.remove('hidden');
      two_video_block_video_2.classList.add('hidden');
      two_video_block_button_1.style.borderBottom = 'thin solid #211912';
      two_video_block_button_2.style.borderBottom = 'none';
    });

    two_video_block_button_2.addEventListener('click', () => {
      two_video_block_video_1.classList.add('hidden');
      two_video_block_video_2.classList.remove('hidden');
      two_video_block_button_1.style.borderBottom = 'none';
      two_video_block_button_2.style.borderBottom = 'thin solid #211912';
    });
  }

  const selected_colors = document.querySelectorAll('.nail-picker-selected-color'); 
  const selected_colors_sticky_atc = document.querySelectorAll('.byteex-stycky-atc-selected-color'); 
  const selected_colors_color_list = document.querySelectorAll('.color-list-selected-color'); 

  const hidden_overlay = document.getElementById('hidden-overlay');
  const color_items = document.querySelectorAll('.nail-picker-color');
  if (color_items.length) {
    color_items[color_items.length - 1].classList.add('nail-picker-color-last');
  }

  const remove_selected_colors = document.querySelectorAll('.remove-selected-color');

  const product_form = document.querySelector('.main-product-form');
  const main_atc_button = document.getElementById('byteex-submit-button');

  const atc_button_text = document.getElementById('atc-button-text');
  const choose_color_button_text = document.getElementById('choose-color-button-text');

  const variant_picker_data = document.getElementById('variant-picker-data');
  let colors_number = variant_picker_data.dataset.maxWrapsNumber;

  const variant_number_pre_selected = variant_picker_data.dataset.variantNumberPreSelected;
  const variant_number_pre_selected_number = parseInt(variant_number_pre_selected) - 1;

  const giftItems = document.querySelectorAll(".gift-item");

  const priceBlocks = document.querySelectorAll(".price-block");
  const priceAtc = document.querySelector(".price-atc");
  const nail_picker_title_wraps_number = document.getElementById('nail-picker-title-wraps-number'); 

  // VARIANT PICKER
  const variantPickerItems = document.querySelectorAll(".variant-picker-item");
  const variantMessage = document.getElementById('variant-message');

  variantPickerItems.forEach((variant, idx, arr) => {
    variant.addEventListener("click", (e) => {
      const current_item = e.currentTarget;
      const id = current_item.dataset.id;
      const giftCount = current_item.dataset.giftCount;
      const wrapsNumber = current_item.dataset.wrapsNumber;
      const message = current_item.dataset.message;

      if (variantMessage) {
        variantMessage.textContent = message;
      }

      if (nail_picker_title_wraps_number) {
        nail_picker_title_wraps_number.textContent = wrapsNumber;
      }

      priceBlocks.forEach((block, index) => {
        block.style.display = "none";

        if (idx === index) {
          block.style.display = "block";

          const priceBlockData = block.querySelector(".price-block-data");
          const price = priceBlockData.dataset.price;
          const comparePrice = priceBlockData.dataset.comparePrice;

          if (priceAtc.children[0]) {
            priceAtc.children[0].innerHTML = price;
          }

          if (priceAtc.children[1]) {
            priceAtc.children[1].innerHTML = comparePrice;
          }

          // Drive the visible ATC button price + compare-at price with the
          // shared digit-tick animation (falls back to a plain swap if the
          // tick API hasn't loaded yet).
          const tick = (el, text) => {
            if (window.btfTickPrice) {
              window.btfTickPrice(el, text);
            } else {
              el.textContent = text;
              el._tickLogicalText = text;
            }
          };
          const toNum = (s) => parseFloat(String(s).replace(/[^\d.]/g, "")) || 0;
          const showCompare = toNum(comparePrice) > toNum(price);

          document.querySelectorAll("[data-atc-price]").forEach((el) => tick(el, price));
          document.querySelectorAll("[data-atc-compare]").forEach((el) => {
            if (showCompare) {
              el.style.display = "";
              tick(el, comparePrice);
            } else {
              el.style.display = "none";
            }
          });
        }
      });

      colors_number = parseInt(wrapsNumber) || 0;
      
      giftItems.forEach((item, idx) => {
        const image = item.querySelector("img");
        const svg = item.querySelector(".lock-icon");

        image.style.display = "block";
        svg.style.display = "none";

        if (idx > giftCount - 1) {
          image.style.display = "none";
          svg.style.display = "block";
        }
      });

      selected_colors.forEach((color, idx) => {
        const image = color.querySelector("img");
        const plus_icon = color.querySelector("span");
        const lock_icon = color.querySelector(".lock-icon");
        const remove_button = color.querySelector(".remove-selected-color");
        const color_name = color.querySelector("p");
        const isSelected = color.dataset.selected;
        const image_wrapper = color.firstElementChild;

        const freeCount = parseInt(current_item.dataset.giftCount) || 0;

        if (idx > 0) {
          const free_label = color.querySelector('.nail-picker-selected-color-free-label');
          if (free_label) {
            if (freeCount > 0 && idx <= colors_number - 1 && idx >= colors_number - freeCount) {
              free_label.style.display = 'block';
            } else {
              free_label.style.display = 'none';
            }
          }
        }        

        if (!isSelected || isSelected === "false") {
          image.style.opacity = "1";
          plus_icon.style.display = "block";
          lock_icon.style.display = "none";

          const current_selected_colors_sticky_atc = selected_colors_sticky_atc[idx];
          if (current_selected_colors_sticky_atc) {
            const img = current_selected_colors_sticky_atc.querySelector('img');
            if (img) {
              img.style.opacity = "1";
            }

            const span = current_selected_colors_sticky_atc.querySelector('span');
            if (span) {
              span.style.display = "block";
            }

            const lock_icon = current_selected_colors_sticky_atc.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "none";
            }
          }

          const current_selected_colors_color_list = selected_colors_color_list[idx];
          if (current_selected_colors_color_list) {
            const img = current_selected_colors_color_list.querySelector('img');
            if (img) {
              img.style.opacity = "1";
            }

            const span = current_selected_colors_color_list.querySelector('span');
            if (span) {
              span.style.display = "block";
            }

            const lock_icon = current_selected_colors_color_list.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "none";
            }
          }
        }

        if (idx > colors_number - 1) {
          color.removeAttribute("data-selected");
          color.removeAttribute("data-id");

          image.removeAttribute('src');
          image.classList.add('hidden');
          color_name.textContent = `${placeholder_color_name} ${idx + 1}`;

          const current_selected_colors_sticky_atc = selected_colors_sticky_atc[idx];
          if (current_selected_colors_sticky_atc) {
            const img = current_selected_colors_sticky_atc.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            const span = current_selected_colors_sticky_atc.querySelector('span');
            if (span) {
              span.style.display = "none";
            }

            const lock_icon = current_selected_colors_sticky_atc.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "block";
            }

            current_selected_colors_sticky_atc.style.backgroundColor = "#FAF7F5";
            current_selected_colors_sticky_atc.style.borderColor = "#2119124D";
          }

          const current_selected_colors_color_list = selected_colors_color_list[idx];
          if (current_selected_colors_color_list) {
            const img = current_selected_colors_color_list.querySelector('img');
            if (img) {
              img.removeAttribute('src');
              img.classList.add('hidden');
            }

            const span = current_selected_colors_color_list.querySelector('span');
            if (span) {
              span.style.display = "none";
            }

            const lock_icon = current_selected_colors_color_list.querySelector('.lock-icon');
            if (lock_icon) {
              lock_icon.style.display = "block";
            }

            current_selected_colors_color_list.style.backgroundColor = "#FAF7F5";
            current_selected_colors_color_list.style.borderColor = "#2119124D";
          }

          plus_icon.style.display = "none";
          lock_icon.style.display = "block";
          remove_button.style.display = "none";

          image_wrapper.style.backgroundColor = "#FAF7F5";
          image_wrapper.style.border = "2px dashed #E5D5C5";
        } else {
          image_wrapper.style.backgroundColor = "#ffffff";
          
          if (isSelected === "true" || isSelected === true) {
            image_wrapper.style.border = "none";
          } else {
            image_wrapper.style.border = "2px dashed #D9C4A8";
          }

          const current_selected_colors_sticky_atc = selected_colors_sticky_atc[idx];
          if (current_selected_colors_sticky_atc) {
            current_selected_colors_sticky_atc.style.backgroundColor = "#ffffff";
            current_selected_colors_sticky_atc.style.borderColor = "#211912B2";
          }

          const current_selected_colors_color_list = selected_colors_color_list[idx];
          if (current_selected_colors_color_list) {
            current_selected_colors_color_list.style.backgroundColor = "#ffffff";
            current_selected_colors_color_list.style.borderColor = "#211912B2";
          }
        }
      });

      const count = getSelectedCount();

      if (count === colors_number) {      
        color_items.forEach(color_item => {
          const add_color_item_button = color_item.querySelector('.add-color-item-button');
          const selection_completed_button = color_item.querySelector('.selection-completed-button');
          const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper'); 
  
          add_color_item_button.classList.add('hidden');
          selection_completed_button.classList.remove('hidden');
          quantity_color_item_wrapper.classList.add('hidden');

          const color_id = color_item.dataset.id;
          const color_count = checkSelectedColor(color_id);
          const color_item_count = color_item.querySelector('.color-item-count-container');
  
          if (color_count > 0) {
            if (color_item_count) {
              updateSlotMachine(color_item_count, color_count);
            }
          } else {
            if (color_item_count) {
              updateSlotMachine(color_item_count, 0);
            }
  
            const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');  
            current_color_img.classList.remove('selected-color-item');
          }
        });
      } else {
        color_items.forEach(color_item => {
          const color_id = color_item.dataset.id;
          const color_count = checkSelectedColor(color_id);
          const color_item_count = color_item.querySelector('.color-item-count-container');

          const selection_completed_button = color_item.querySelector('.selection-completed-button');
          selection_completed_button.classList.add('hidden');
  
          if (color_count > 0) {        
            const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper');
            quantity_color_item_wrapper.classList.remove('hidden');

            if (color_item_count) {
              updateSlotMachine(color_item_count, color_count);
            }
          } else {
            const add_color_item_button = color_item.querySelector('.add-color-item-button');
            add_color_item_button.classList.remove('hidden');

            if (color_item_count) {
              updateSlotMachine(color_item_count, 0);
            }
  
            const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');  
            current_color_img.classList.remove('selected-color-item');
  
            const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper'); 
            if (quantity_color_item_wrapper) {
              quantity_color_item_wrapper.classList.add('hidden');
            }
          }
        });
      }

      const productId = document.getElementById("product-id");
      productId.value = id;
      product_form.dataset.variantId = id;

      const current_properties_block = document.getElementById('nail-picker-properties-block');
      if (current_properties_block) {
        current_properties_block.remove();
      }

      if (count === colors_number) {
        setAtcButtonState(true);
        main_atc_button.type = 'submit';

        const checkoutFlow = document.getElementById('section-wrapper')?.dataset.checkoutFlow || 'v1';

        if (checkoutFlow === 'v2') {
          atc_button_text.innerHTML = '<span>ADDING TO CART...</span>';
          main_atc_button.style.pointerEvents = 'none';
          window.__v2AutoClick = true;
          main_atc_button.click();
        } else if (checkoutFlow === 'v3') {
          atc_button_text.innerHTML = '<span>CONTINUE TO CHECKOUT</span>';
        }

        const properties_block = document.createElement('div');
        properties_block.setAttribute('id', 'nail-picker-properties-block');
        
        selected_colors.forEach((color, i) => {
          const isCurrentSelected = color.dataset.selected;

          if (isCurrentSelected) {
            const id = color.dataset.id;

            const text_tag = color.querySelector('p');
            const title = text_tag.textContent;

            const img_tag = color.querySelector('img');
            const image = img_tag.dataset.imageLineItem;

            const hiddenField1 = document.createElement('input');
            hiddenField1.setAttribute('type', "hidden");
            hiddenField1.setAttribute('class', `class${i + 1}`);
            hiddenField1.setAttribute('name', `properties[_${i + 1}.]`);
            hiddenField1.setAttribute('value', image);
            properties_block.appendChild(hiddenField1);        

            const hiddenField2 = document.createElement('input');
            hiddenField2.setAttribute('type', "hidden");
            hiddenField2.setAttribute('class', `class${i + 1}`);
            hiddenField2.setAttribute('name', `properties[Gel ${i + 1}]`);
            hiddenField2.setAttribute('value', title);
            properties_block.appendChild(hiddenField2);

            const hiddenField3 = document.createElement('input');
            hiddenField3.setAttribute('type', "hidden");
            hiddenField3.setAttribute('class', `class${i + 1}`);
            hiddenField3.setAttribute('name', `properties[_id${i + 1}.]`);
            hiddenField3.setAttribute('value', id);
            properties_block.appendChild(hiddenField3);
          }
        });

        product_form.appendChild(properties_block);
      } else {
        setAtcButtonState(false);
        main_atc_button.type = 'button';
      }
    });
  });

  variantPickerItems[variant_number_pre_selected_number].click();

  // *** NAIL PICKER *** //

  const nail_picker_color_open_popup = document.querySelectorAll('.nail-picker-color-open-popup');
  const nail_picker_color_close_popup = document.querySelectorAll('.nail-picker-color-close-popup');
  const nail_picker_color_popup_add_buttons = document.querySelectorAll('.nail-picker-color-popup-add-button');
  const remove_selected_color_items = document.querySelectorAll('.remove-selected-color-item');

  // OPEN COLOR LIST POPUP
  const nail_picker_color_list_wrapper = document.getElementById('nail-picker-color-list-wrapper');
  
  main_atc_button.addEventListener('click', (event) => {
    if (window.__v2AutoClick) {
      window.__v2AutoClick = false;
      return;
    }

    const current_target = event.currentTarget;
    const button_type = current_target.type;
    const checkoutFlow = document.getElementById('section-wrapper')?.dataset.checkoutFlow || 'v1';

    if (button_type === 'button' && checkoutFlow === 'v1') {
      const target = document.querySelector('.custom-bundle-wrapper');
      if (target) {
        const isMobile = window.innerWidth < 768;
        const offset = isMobile ? 300 : 50;
        const targetY = target.getBoundingClientRect().top + window.scrollY + offset;
        //                                                                  ↑ changed from − to +
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
    }
  });

  selected_colors.forEach(color => {
    color.addEventListener('click', (event) => {
    });
  });

  // CLOSE COLOR LIST POPUP
  const nail_picker_color_list_close_popup = document.querySelectorAll('.nail-picker-color-list-close-popup');
  nail_picker_color_list_close_popup.forEach(item => {
    item.addEventListener('click', (event) => {
      hidden_overlay.classList.add('hidden');
      nail_picker_color_list_wrapper.classList.add('hidden');

      document.body.style.overflow = 'auto';
    });
  });

  // open guarantee popup
  const guarantee_popup_open_button = document.getElementById('guarantee-popup-open-button');
  const guarantee_popup_content = document.getElementById('guarantee-popup-content');
  const guarantee_popup_close_buttons = document.querySelectorAll('.guarantee-popup-close-button');

  if (guarantee_popup_open_button && guarantee_popup_content) {
    guarantee_popup_open_button.addEventListener('click', () => {
      guarantee_popup_content.classList.remove('hidden');
      nail_picker_color_list_wrapper.style.overflowY = 'hidden';
    });
  }

  if (guarantee_popup_close_buttons && guarantee_popup_content) { 
    guarantee_popup_close_buttons.forEach(item => {
      item.addEventListener('click', () => {
        guarantee_popup_content.classList.add('hidden');
        nail_picker_color_list_wrapper.style.overflowY = 'auto';
      });
    });
  }

  // --- COLOR POPUP --- //
  
  let slider = null;
  function sliderInit(elementId) {
    function sliderNavigation(slider) {
      let controlsWrapper, dots, arrowLeft, arrowRight;
    
      function removeElement(el) {
        el?.parentNode?.removeChild(el);
      }
    
      function createDiv(className) {
        const div = document.createElement("div");
        className.split(" ").forEach(name => div.classList.add(name));
        return div;
      }
    
      function controlsMarkup(remove) {
        if (remove) {
          removeElement(controlsWrapper);
          return;
        }
    
        controlsWrapper = createDiv("product-image-keen-slider-navigation-controls");
    
        arrowLeft = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--left");
        arrowRight = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--right");
    
        arrowLeft.innerHTML = " "; 
        arrowRight.innerHTML = " ";
    
        arrowLeft.addEventListener("click", () => slider.prev());
        arrowRight.addEventListener("click", () => slider.next());
    
        controlsWrapper.appendChild(arrowLeft);
        controlsWrapper.appendChild(arrowRight);
    
        dots = createDiv("product-image-keen-slider-dots");
        const totalSlides = slider.track.details.slides.length;
    
        for (let i = 0; i < totalSlides; i++) {
          const dot = createDiv("product-image-keen-slider-dot");
          dot.addEventListener("click", () => slider.moveToIdx(i));
          dots.appendChild(dot);
        }
    
        controlsWrapper.appendChild(dots);
        slider.container.parentNode.appendChild(controlsWrapper);
      }
    
      function updateClasses() {
        const rel = slider.track.details.rel;
    
        if (dots) {
          Array.from(dots.children).forEach((dot, idx) => {
            dot.classList.toggle("product-image-keen-slider-dot--active", idx === rel);
          });
        }
    
        if (arrowLeft && arrowRight) {
          const maxIdx = slider.track.details.slides.length - 1;
          arrowLeft.classList.toggle("disabled", rel === 0);
          arrowRight.classList.toggle("disabled", rel === maxIdx);
        }
      }
    
      slider.on("created", () => {
        controlsMarkup();
        updateClasses();
      });
    
      slider.on("slideChanged", updateClasses);
      slider.on("destroyed", () => controlsMarkup(true));
    }
    
    slider = new KeenSlider(
      elementId,
      {
        loop: false,
        slides: { perView: 1, spacing: 16 }
      },
      [sliderNavigation]
    );
  };

  nail_picker_color_open_popup.forEach(item => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_color = event.currentTarget;
      const data_popup_id = current_color.dataset.popupId;

      const color_popup = document.getElementById(data_popup_id);
      if (color_popup) {
        color_popup.classList.remove('hidden');
        nail_picker_color_list_wrapper.style.overflowY = 'hidden';

        const slider_container = color_popup.querySelector('.keen-slider');

        if (slider_container) {
          sliderInit(slider_container);
        }
      }      
    });
  });

  nail_picker_color_close_popup.forEach(item => { 
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_color = event.currentTarget;
      const data_id = current_color.dataset.id;      

      if (slider) {
        slider.destroy();
        slider = null;
      }

      const choose_color_popup = document.getElementById(data_id);
      choose_color_popup.classList.add('hidden');
      nail_picker_color_list_wrapper.style.overflowY = 'auto';
    });
  });

  // --- ADD COLORS TO PICKER --- //

  function getSelectedCount() {
    let count = 0;
    selected_colors.forEach(color => {
      const isSelected = color.dataset.selected;
      if (isSelected) {
        count++;
      }
    });
    return count;
  }

  function addColor(id, image, image_line_item, title) {
    let loop_count = -1;
    for (const color of selected_colors) {
      loop_count++;
      const isSelected = color.dataset.selected;

      if (!isSelected) {
        const img = color.querySelector('img');
        img.setAttribute('src', image);
        img.classList.remove('hidden');
        img.dataset.imageLineItem = image_line_item;

        const current_selected_colors_sticky_atc = selected_colors_sticky_atc[loop_count];
        if (current_selected_colors_sticky_atc) {
          const img = current_selected_colors_sticky_atc.querySelector('img');
          if (img) {
            img.setAttribute('src', image);
            img.classList.remove('hidden');
          }

          const span = current_selected_colors_sticky_atc.querySelector('span');
          if (span) {
            span.style.display = "none";
          }
        }

        const current_selected_colors_color_list = selected_colors_color_list[loop_count];
        if (current_selected_colors_color_list) {
          const img = current_selected_colors_color_list.querySelector('img');
          if (img) {
            img.setAttribute('src', image);
            img.classList.remove('hidden');
          }

          const span = current_selected_colors_color_list.querySelector('span');
          if (span) {
            span.style.display = "none";
          }
        }

        const color_name = color.querySelector('p');
        color_name.textContent = title;

        const plus_icon = color.querySelector('span');
        plus_icon.style.display = 'none';

        const remove_button = color.querySelector('.remove-selected-color');
        remove_button.style.display = 'block';
        
        color.dataset.selected = true;
        color.dataset.id = id;
        color.firstElementChild.style.border = 'none';

        break;
      }
    }

    const count = getSelectedCount();
    
    const current_properties_block = document.getElementById('nail-picker-properties-block');

    if (count === colors_number) {
      if (current_properties_block) {
        current_properties_block.remove();
      }

      color_items.forEach(color_item => {
        const add_color_item_button = color_item.querySelector('.add-color-item-button');
        const selection_completed_button = color_item.querySelector('.selection-completed-button');
        const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper'); 

        add_color_item_button.classList.add('hidden');
        selection_completed_button.classList.remove('hidden');
        quantity_color_item_wrapper.classList.add('hidden');
      });

      hidden_overlay.classList.add('hidden');
      nail_picker_color_list_wrapper.classList.add('hidden');
      document.body.style.overflow = 'auto';

      setAtcButtonState(true);
      main_atc_button.type = 'submit';

      const checkoutFlow = document.getElementById('section-wrapper')?.dataset.checkoutFlow || 'v1';

      if (checkoutFlow === 'v2') {
        atc_button_text.innerHTML = '<span>ADDING TO CART...</span>';
        main_atc_button.style.pointerEvents = 'none';
        window.__v2AutoClick = true;
        main_atc_button.click();
      } else if (checkoutFlow === 'v3') {
        atc_button_text.innerHTML = '<span>CONTINUE TO CHECKOUT</span>';
      }

      const properties_block = document.createElement('div');
      properties_block.setAttribute('id', 'nail-picker-properties-block');
      
      selected_colors.forEach((color, i) => {
        const is_selected = color.dataset.selected;

        if (is_selected === 'true') {
          const id = color.dataset.id;

          const text_tag = color.querySelector('p');
          const title = text_tag.textContent;

          const img_tag = color.querySelector('img');
          const image = img_tag.dataset.imageLineItem;

          const hiddenField1 = document.createElement('input');
          hiddenField1.setAttribute('type', "hidden");
          hiddenField1.setAttribute('class', `class${i + 1}`);
          hiddenField1.setAttribute('name', `properties[_${i + 1}.]`);
          hiddenField1.setAttribute('value', image);
          properties_block.appendChild(hiddenField1);        

          const hiddenField2 = document.createElement('input');
          hiddenField2.setAttribute('type', "hidden");
          hiddenField2.setAttribute('class', `class${i + 1}`);
          hiddenField2.setAttribute('name', `properties[Gel ${i + 1}]`);
          hiddenField2.setAttribute('value', title);
          properties_block.appendChild(hiddenField2);

          const hiddenField3 = document.createElement('input');
          hiddenField3.setAttribute('type', "hidden");
          hiddenField3.setAttribute('class', `class${i + 1}`);
          hiddenField3.setAttribute('name', `properties[_id${i + 1}.]`);
          hiddenField3.setAttribute('value', id);
          properties_block.appendChild(hiddenField3);
        }
      });

      product_form.appendChild(properties_block);
    }
  }

  // add color to picker from color list
  color_items.forEach(color_item => {
    const add_color_item_button = color_item.querySelector('.add-color-item-button');

    if (add_color_item_button) {      
      add_color_item_button.addEventListener('click', () => {
        const current_color = color_item;
        const data_id = current_color.dataset.id;
        const data_title = current_color.dataset.title;
        const data_image = current_color.dataset.imageAdded || current_color.dataset.imageAddedAlt || current_color.dataset.image;
        const data_image_line_item = current_color.dataset.imageLineItem;

        const current_selected_colors = getSelectedCount();

        if (current_selected_colors < colors_number) {
          const current_color_img = current_color.querySelector('.nail-picker-color-image-wrapper');

          current_color_img.classList.add('selected-color-item');
          current_color.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');

          addColor(data_id, data_image, data_image_line_item, data_title);
          
          const color_count = checkSelectedColor(data_id);
          const color_item_count = current_color.querySelector('.color-item-count-container');

          if (color_item_count) {
            updateSlotMachine(color_item_count, color_count);
          }
        }
      });
    }

    const add_color_item_button_plus = color_item.querySelector('.color-item-count-plus');

    if (add_color_item_button_plus) {
      add_color_item_button_plus.addEventListener('click', () => {
        const current_color = color_item;
        const data_id = current_color.dataset.id;
        const data_title = current_color.dataset.title;
        const data_image = current_color.dataset.imageAdded || current_color.dataset.imageAddedAlt || current_color.dataset.image;
        const data_image_line_item = current_color.dataset.imageLineItem;

        const current_selected_colors = getSelectedCount();

        if (current_selected_colors < colors_number) {
          addColor(data_id, data_image, data_image_line_item, data_title);
          
          const color_count = checkSelectedColor(data_id);
          const color_item_count = current_color.querySelector('.color-item-count-container');

          if (color_item_count) {
            updateSlotMachine(color_item_count, color_count);
          }
        }
      });
    }
  });

  // add color to picker from color popup
  nail_picker_color_popup_add_buttons.forEach(item => {
    item.addEventListener('click', (event) => {
      const current_color = event.currentTarget;
      const data_id = current_color.dataset.id;
      const data_title = current_color.dataset.title;
      const data_image = current_color.dataset.imageAdded || current_color.dataset.imageAddedAlt || current_color.dataset.image;
      const data_image_line_item = current_color.dataset.imageLineItem;
      const data_popup_id = current_color.dataset.popupId;

      const current_selected_colors = getSelectedCount();

      if (current_selected_colors < colors_number) {
        addColor(data_id, data_image, data_image_line_item, data_title);

        const color_item = document.querySelector(`.nail-picker-color[data-id="${data_id}"]`);
        const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');
        current_color_img.classList.add('selected-color-item');
        color_item.querySelector('.quantity-color-item-wrapper').classList.remove('hidden');

        const color_count = checkSelectedColor(data_id);
        const color_item_count = color_item.querySelector('.color-item-count-container');

        if (color_item_count) {
          updateSlotMachine(color_item_count, color_count);
        }
      }
      
      const color_popup = document.getElementById(data_popup_id);
      color_popup.classList.add('hidden');

      if (slider) {
        slider.destroy();
        slider = null;
      }
    });
  });  

  // --- REMOVE COLORS FROM PICKER --- //
  
  function removeProperties() {
    const current_properties_block = document.getElementById('nail-picker-properties-block');

    if (current_properties_block) {
      current_properties_block.remove();
      
      setAtcButtonState(false);
      main_atc_button.type = 'button';
    }
  }

  function checkSelectedColor(data_id) {
    let selected_count = 0;

    for (const color of selected_colors) {
      const color_id = color.dataset.id;

      if (color_id === data_id) {
        selected_count++;
      }
    }

    return selected_count;
  }

  // remove buttons on color items
  remove_selected_color_items.forEach(item => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_item = event.currentTarget;
      const parent = current_item.closest('.nail-picker-color'); 
      const data_id = current_item.dataset.id;      

      let selected_count = 0;
      let selected_index;

      selected_colors.forEach((color, index) => {
        if (color.dataset.id === data_id) {
          selected_count++;
          selected_index = index;
        }
      });

      if (selected_count > 0) {
        const img = selected_colors[selected_index].querySelector('img');
        img.removeAttribute('src');
        img.classList.add('hidden');

        const current_selected_colors_sticky_atc = selected_colors_sticky_atc[selected_index];
        if (current_selected_colors_sticky_atc) {
          const img = current_selected_colors_sticky_atc.querySelector('img');
          if (img) {
            img.removeAttribute('src');
            img.classList.add('hidden');
          }

          const span = current_selected_colors_sticky_atc.querySelector('span');
          if (span) {
            span.style.display = "block";
          }
        }

        const current_selected_colors_color_list = selected_colors_color_list[selected_index];
        if (current_selected_colors_color_list) {
          const img = current_selected_colors_color_list.querySelector('img');
          if (img) {
            img.removeAttribute('src');
            img.classList.add('hidden');
          }

          const span = current_selected_colors_color_list.querySelector('span');
          if (span) {
            span.style.display = "block";
          }
        }

        const color_name = selected_colors[selected_index].querySelector('p');
        color_name.textContent = `${placeholder_color_name} ${selected_index + 1}`;

        const plus_icon = selected_colors[selected_index].querySelector('span');
        plus_icon.style.display = 'block';

        const remove_button = selected_colors[selected_index].querySelector('.remove-selected-color');
        remove_button.style.display = 'none';
        
        selected_colors[selected_index].removeAttribute('data-selected');
        selected_colors[selected_index].removeAttribute('data-id'); 
        selected_colors[selected_index].firstElementChild.style.border = '2px dashed #D9C4A8';

      }

      if (selected_count === 1) {
        const current_color_img = parent.querySelector('.nail-picker-color-image-wrapper');
        current_color_img.classList.remove('selected-color-item');
        parent.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
        parent.querySelector('.add-color-item-button').classList.remove('hidden');
      }

      const color_item_count = parent.querySelector('.color-item-count-container');
      const color_count = checkSelectedColor(data_id);
      if (color_count > 0) {        
        if (color_item_count) {
          updateSlotMachine(color_item_count, color_count);
        }
      } else {
        if (color_item_count) {
          updateSlotMachine(color_item_count, 0);
        }
      }

      removeProperties();
    });
  });

  // remove buttons on selected colors
  remove_selected_colors.forEach((item, i) => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      const current_color = event.currentTarget;
      const parent = current_color.parentElement;
      const item_number = i;

      const color_id = parent.dataset.id;
      const current_selected_color_count = checkSelectedColor(color_id);

      const count = getSelectedCount();
      if (count === colors_number) {      
        color_items.forEach(color_item => {
          const color_id = color_item.dataset.id;
          const color_count = checkSelectedColor(color_id);

          const selection_completed_button = color_item.querySelector('.selection-completed-button');
          selection_completed_button.classList.add('hidden');

          if (color_count > 0) {
            const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper'); 
            quantity_color_item_wrapper.classList.remove('hidden');
          } else {
            const add_color_item_button = color_item.querySelector('.add-color-item-button');
            add_color_item_button.classList.remove('hidden');
          }
        });
      }

      const color_item = document.querySelector(`.nail-picker-color[data-id="${color_id}"]`);
      if (current_selected_color_count === 1) {
        if (color_item) {
          const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');
          current_color_img.classList.remove('selected-color-item');
          color_item.querySelector('.quantity-color-item-wrapper').classList.add('hidden');
          color_item.querySelector('.add-color-item-button').classList.remove('hidden');
        }
      }

      const img = parent.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const current_selected_colors_sticky_atc = selected_colors_sticky_atc[item_number];
      if (current_selected_colors_sticky_atc) {
        const img = current_selected_colors_sticky_atc.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const span = current_selected_colors_sticky_atc.querySelector('span');
        if (span) {
          span.style.display = "block";
        }
      }

      const current_selected_colors_color_list = selected_colors_color_list[item_number];
      if (current_selected_colors_color_list) {
        const img = current_selected_colors_color_list.querySelector('img');
        if (img) {
          img.removeAttribute('src');
          img.classList.add('hidden');
        }

        const span = current_selected_colors_color_list.querySelector('span');
        if (span) {
          span.style.display = "block";
        }
      }

      const color_name = parent.querySelector('p');
      color_name.textContent = `${placeholder_color_name} ${item_number + 1}`;

      const plus_icon = parent.querySelector('span');
      plus_icon.style.display = 'block';

      const remove_button = parent.querySelector('.remove-selected-color');
      remove_button.style.display = 'none';
      
      parent.removeAttribute('data-selected');
      parent.removeAttribute('data-id');

      parent.firstElementChild.style.border = '2px dashed #D9C4A8';

      if (color_item) {
        const color_item_count = color_item.querySelector('.color-item-count-container');
        const color_count = checkSelectedColor(color_id);
        if (color_count > 0) {        
          if (color_item_count) {
            updateSlotMachine(color_item_count, color_count);
          }
        } else {
          if (color_item_count) {
            updateSlotMachine(color_item_count, 0);
          }
        }
      }

      removeProperties();
    });
  });

  // CLEAR NAIL PICKER AFTER ADDING PRODUCT TO CART
  window.clearNailPickerGelWraps = function() {
    atcPreviouslyFull = false; // reset flag so next fill triggers the flip

    const redirectingEl = document.getElementById('redirecting-button-text');
    const addingEl = document.getElementById('adding-to-cart-button-text');
    const addedEl  = document.getElementById('added-to-cart-button-text');
    const atcEl    = document.getElementById('atc-button-text');
    const chooseEl = document.getElementById('choose-color-button-text');

    if (redirectingEl) { redirectingEl.style.display = 'none'; redirectingEl.classList.remove('rolling-in', 'rolling-out-up', 'rolling-out-down', 'rolling-in-from-top'); }
    if (addingEl)     { addingEl.style.display = 'none';     addingEl.classList.remove('rolling-in', 'rolling-out-up', 'rolling-out-down', 'rolling-in-from-top'); }
    if (addedEl)      { addedEl.style.display = 'none';      addedEl.classList.remove('rolling-in', 'rolling-out-up', 'rolling-out-down', 'rolling-in-from-top'); }
    if (atcEl)        { atcEl.style.display = 'none';        atcEl.classList.remove('rolling-in', 'rolling-out-up', 'rolling-out-down', 'rolling-in-from-top'); }
    if (chooseEl)     { chooseEl.style.display = 'flex';     chooseEl.classList.remove('rolling-in', 'rolling-out-up', 'rolling-out-down', 'rolling-in-from-top'); }

    const atcBtnText = document.getElementById('atc-button-text');
    const sectionWrapperEl = document.getElementById('section-wrapper');
    if (atcBtnText && sectionWrapperEl) {
      const defaultText = sectionWrapperEl.dataset.addToCartText || 'ADD TO CART';
      atcBtnText.innerHTML = '<span>' + defaultText + '</span>';
    }
    selected_colors.forEach((item, i) => {
      const img = item.querySelector('img');
      img.removeAttribute('src');
      img.classList.add('hidden');
      img.style.opacity = '1';

      const color_name = item.querySelector('p');
      color_name.textContent = `${placeholder_color_name} ${i + 1}`;

      const plus_icon = item.querySelector('span');
      plus_icon.style.display = 'block';

      const remove_button = item.querySelector('.remove-selected-color');
      remove_button.style.display = 'none';

      const lock_icon = item.querySelector(".lock-icon");
      lock_icon.style.display = 'none';
      
      item.removeAttribute('data-selected');
      item.removeAttribute('data-id');
      
      const image_wrapper = item.firstElementChild;
      image_wrapper.style.backgroundColor = "#ffffff";
      image_wrapper.style.border = "2px dashed #D9C4A8";

      const free_label = item.querySelector('.nail-picker-selected-color-free-label');
      if (free_label) {
        if (i > 3) {
          free_label.style.display = 'block';
        } else {
          free_label.style.display = 'none';
        }
      }
    });

    selected_colors_sticky_atc.forEach(item => {
      const img = item.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const plus_icon = item.querySelector('span');
      if (plus_icon) {
        plus_icon.style.display = 'block';
      }

      const lock_icon = item.querySelector('.lock-icon');
      if (lock_icon) {
        lock_icon.style.display = 'none';
      }

      item.style.backgroundColor = "#ffffff";
      item.style.borderColor = "#211912B2";
    });

    selected_colors_color_list.forEach(item => {
      const img = item.querySelector('img');
      if (img) {
        img.removeAttribute('src');
        img.classList.add('hidden');
      }

      const span = item.querySelector('span');
      if (span) {
        span.style.display = "block";
      }
    });

    removeProperties();

    variantPickerItems[variant_number_pre_selected_number].click();

    color_items.forEach(color_item => {
      const color_item_count = color_item.querySelector('.color-item-count-container');
      if (color_item_count) {
        updateSlotMachine(color_item_count, 0);
      }
      
      const selection_completed_button = color_item.querySelector('.selection-completed-button');
      selection_completed_button.classList.add('hidden');

      const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper');
      if (quantity_color_item_wrapper) {
        quantity_color_item_wrapper.classList.add('hidden');
      }

      const add_color_item_button = color_item.querySelector('.add-color-item-button');
      if (add_color_item_button) {
        add_color_item_button.classList.remove('hidden');
      }

      const current_color_img = color_item.querySelector('img');
      current_color_img.classList.remove('selected-color-item');
    });
  }

// ============================================================
// LOOP SUBSCRIPTION INTEGRATION — v4 (ported from Skio)
// Reads native Shopify selling plans (populated by Loop) from Liquid;
// no external subscription-app API call is made.
// ============================================================

;(function initLoopIntegration() {
  const variantPickerData = document.getElementById('variant-picker-data');
  if (!variantPickerData) return;

  const sectionWrapper = document.getElementById('section-wrapper');
  if (!sectionWrapper) return;

  const product_id = sectionWrapper.dataset.productId;
  const product_price = parseInt(sectionWrapper.dataset.price);
  const currencySymbol = sectionWrapper.dataset.currencySymbol || '£';

  if (!product_id || !product_price) {
    console.warn('[Loop] Missing productId or price');
    return;
  }
  // ─── State ───
  let build_a_box_id = null;
  let selling_plans_ids = [];
  let selected_selling_plan_id = null;
  let selectedVariantIndex = 0;
  let percentDiscountTiers = {};
  let loopReady = false;

  // ─── DOM refs ───
  const pricePerWrapElements = document.querySelectorAll('.price-per-wrap');
  const variantPriceElements = document.querySelectorAll('.variant-price');
  const discountPercentageElements = document.querySelectorAll('.discount-percentage');
  const priceBlockLoaderElement = document.querySelector('.price-block-loader');
  const priceBlockContentElements = document.querySelectorAll('.price-block-content');
  const priceBlockElements = document.querySelectorAll('.price-block');
  const variantPickerItems = document.querySelectorAll('.variant-picker-item');
  const variantNumberPreSelected = parseInt(variantPickerData.dataset.variantNumberPreSelected) || 1;

  const subscriptionPercentEl = document.getElementById('subscription-percent');
  const subscriptionWrapsNumberEl = document.getElementById('subscription-wraps-number');
  const subscriptionTermEl = document.getElementById('subscription-term');
  const subscriptionPricePerWrapEl = document.getElementById('subscription-price-per-wrap');
  const subscriptionPickerFirstItem = document.querySelector('.subscription-picker-first-item');

  function getDiscountForWraps(wrapsCount) {
    const tierKeys = Object.keys(percentDiscountTiers);
    if (tierKeys.length === 0) return 0;
    if (tierKeys.length === 1) return percentDiscountTiers[tierKeys[0]];
    if (percentDiscountTiers[wrapsCount] !== undefined) return percentDiscountTiers[wrapsCount];

    let bestTier = 0;
    let bestDiscount = 0;
    for (const tier of tierKeys) {
      const t = parseInt(tier);
      if (t <= wrapsCount && t > bestTier) {
        bestTier = t;
        bestDiscount = percentDiscountTiers[tier];
      }
    }
    return bestDiscount;
  }

  function applyPricingAndPlans() {
    selectedVariantIndex = variantNumberPreSelected - 1;
    if (selling_plans_ids.length > selectedVariantIndex) {
      selected_selling_plan_id = selling_plans_ids[selectedVariantIndex].id;
    }

    variantPickerItems.forEach((item, i) => {
      const numberOfWraps = parseInt(item.dataset.wrapsNumber) || 1;
      const discountPercent = getDiscountForWraps(numberOfWraps);
      const perSetPrice = Math.round(
        ((product_price - (product_price * discountPercent) / 100) / 100) * 100
      ) / 100;

      if (pricePerWrapElements[i]) pricePerWrapElements[i].textContent = perSetPrice.toFixed(2);
      if (variantPriceElements[i]) variantPriceElements[i].textContent = (perSetPrice * numberOfWraps).toFixed(2);
      if (discountPercentageElements[i]) discountPercentageElements[i].textContent = discountPercent;

      // Also update bundle card badge if present
      const variantItem = variantPickerItems[i];
      if (variantItem) {
        const cardBadge = variantItem.querySelector('.discount-percentage');
        if (cardBadge) cardBadge.textContent = discountPercent;
      }

      const bundleCardPerSetElements = document.querySelectorAll('.bundle-card-per-set');
      if (bundleCardPerSetElements[i]) {
        bundleCardPerSetElements[i].textContent = currencySymbol + perSetPrice.toFixed(2);
      }

      const priceBlock = priceBlockElements[i];
      if (priceBlock) {
        const pbd = priceBlock.querySelector('.price-block-data');
        if (pbd) {
          pbd.dataset.price = currencySymbol + (perSetPrice * numberOfWraps).toFixed(2);
          pbd.dataset.comparePrice = currencySymbol + ((product_price * numberOfWraps) / 100).toFixed(2);
        }

        // Update the -X% badge beside compare price
        const badge = priceBlock.querySelector('.discount-percentage-badge');
        if (badge) badge.textContent = discountPercent;

        // Hide compare price + badge when discount is 0%
        const compareEl = priceBlock.querySelector('.line-through');
        const badgeWrapper = badge?.parentElement;
        if (discountPercent === 0) {
          if (compareEl) compareEl.style.display = 'none';
          if (badgeWrapper) badgeWrapper.style.display = 'none';
        } else {
          if (compareEl) compareEl.style.display = '';
          if (badgeWrapper) badgeWrapper.style.display = '';
        }
      }
    });

    if (priceBlockLoaderElement) priceBlockLoaderElement.classList.add('hidden');
    priceBlockContentElements.forEach((el) => {
      el.classList.remove('hidden');
      el.classList.add('flex');
    });

    variantPickerItems.forEach((item, i) => {
      item.addEventListener('click', () => {
        selectedVariantIndex = i;
        if (i < selling_plans_ids.length) {
          selected_selling_plan_id = selling_plans_ids[i].id;
        }
        priceBlockElements.forEach((block, idx) => {
          block.style.display = idx === i ? 'block' : 'none';
        });

        // Update subscription block with data for the selected variant
        const numberOfWraps = parseInt(item.dataset.wrapsNumber) || 1;
        const discountPercent = getDiscountForWraps(numberOfWraps);
        const perSetPrice = Math.round(((product_price - (product_price * discountPercent) / 100) / 100) * 100) / 100;

        // Subscription savings always shows the highest discount tier (not active variant's)
        let maxDiscount = 0;
        Object.values(percentDiscountTiers).forEach(function (d) {
          if (d > maxDiscount) maxDiscount = d;
        });
        if (subscriptionPercentEl) subscriptionPercentEl.textContent = maxDiscount;
        // Update Layout B starter kit block if present
        if (typeof window.__btfStarterKitBUpdate === 'function') {
          var subscriptionPrice = perSetPrice * numberOfWraps;
          var subscriptionCompare = (product_price * numberOfWraps) / 100;
          var subscriptionDiscount = subscriptionCompare > 0 ? Math.round(((subscriptionCompare - subscriptionPrice) / subscriptionCompare) * 100) : 0;

          var dataPacket = {
            wraps: numberOfWraps,
            term: plan?.interval_count > 1 ? plan.interval_count + ' ' + plan.interval + 's' : (plan?.interval_count + ' ' + plan?.interval),
            price: subscriptionPrice.toFixed(2),
            discount: discountPercent,
            maxDiscount: maxDiscount,
            subPrice: subscriptionPrice.toFixed(2),
            subCompare: subscriptionCompare.toFixed(2),
            subDiscount: subscriptionDiscount
          };

          window.__btfLastLoopData = dataPacket;  // cache for toggle ON re-apply
          window.__btfStarterKitBUpdate(dataPacket);
        }
        if (subscriptionWrapsNumberEl) subscriptionWrapsNumberEl.textContent = numberOfWraps;
        if (subscriptionPricePerWrapEl) subscriptionPricePerWrapEl.textContent = (perSetPrice * numberOfWraps).toFixed(2);

        const plan = selling_plans_ids[i];
        if (plan && subscriptionTermEl) {
          if (plan.interval_count > 1) {
            subscriptionTermEl.textContent = `${plan.interval_count} ${plan.interval}s`;
          } else {
            subscriptionTermEl.textContent = `${plan.interval_count} ${plan.interval}`;
          }
        }
      });
    });

    if (variantPickerItems[variantNumberPreSelected - 1]) {
      variantPickerItems[variantNumberPreSelected - 1].click();
    }

    if (subscriptionPickerFirstItem) subscriptionPickerFirstItem.classList.remove('opacity-0');

    loopReady = true;

    window.__loopState = {
      get sellingPlanId() { return selected_selling_plan_id; },
      get variantIndex() { return selectedVariantIndex; },
      get boxId() { return build_a_box_id; },
      get sellingPlans() { return selling_plans_ids; },
      get discountTiers() { return percentDiscountTiers; },
    };
  }

  function useLiquidFallback() {
    const rawPlans = variantPickerData.dataset.sellingPlans;
    if (rawPlans) {
      try {
        const plans = JSON.parse(rawPlans);
        selling_plans_ids = plans.map((p) => ({
          id: p.id.toString().replace('gid://shopify/SellingPlan/', ''),
          name: p.name,
        }));
      } catch (e) {
        console.error('[Loop] Failed to parse Liquid selling plans:', e);
      }
    }
    applyPricingAndPlans();
  }

  // ─────────────────────────────────────────────
  // 1. CAPTURE-PHASE CLICK HANDLER ON ATC BUTTON
  // ─────────────────────────────────────────────
  window.__loopCartOverride = true;

  const loopAtcBtn = document.getElementById('byteex-submit-button');
  if (loopAtcBtn) {
    loopAtcBtn.addEventListener('click', function (e) {
      if (!window.__loopCartOverride) return;
      if (this.type !== 'submit') return;
      if (window.__v3RedirectLocked) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }
      
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!loopReady) {
        console.warn('[Loop] Data not loaded yet');
        return;
      }

      this.classList.add('loading');
      this.disabled = true;

      // Pick the visible picker's slots (subscription if toggle ON, onetime if OFF)
      var visiblePickerId = window.__btfSubscribeOn === false ? 'btf-picker-onetime' : 'btf-picker-subscription';
      var visiblePicker = document.getElementById(visiblePickerId);
      const selectedColors = visiblePicker
        ? visiblePicker.querySelectorAll('.nail-picker-selected-color')
        : document.querySelectorAll('.nail-picker-selected-color');
      const selectedColorIds = [];
      selectedColors.forEach((color) => {
        const id = color.dataset.id;
        const isSelected = color.dataset.selected;
        if (id && isSelected === 'true') {
          selectedColorIds.push(id);
        }
      });

      if (selectedColorIds.length === 0) {
        console.warn('[Loop] No colors selected');
        this.classList.remove('loading');
        this.disabled = false;
        return;
      }

      // --- OPTIMISTIC UI: show loading state immediately ---
      const checkoutFlow = document.getElementById('section-wrapper')?.dataset.checkoutFlow || 'v1';
      const atcElOptimistic = document.getElementById('atc-button-text');

      if (checkoutFlow === 'v3') {
        const redirectingElOptimistic = document.getElementById('redirecting-button-text');
        if (atcElOptimistic && redirectingElOptimistic) {
          playAtcFlip(atcElOptimistic, redirectingElOptimistic);
        }
      } else {
        // v1 & v2: flip to "Adding to cart..."
        const addingElOptimistic = document.getElementById('adding-to-cart-button-text');
        if (atcElOptimistic && addingElOptimistic) {
          playAtcFlip(atcElOptimistic, addingElOptimistic);
        }
      }

      const activeVariant = document.querySelector('.variant-picker-item.active-variant');

      const giftProductIds = [];
      const giftProductHandles = [];

      // Read gifts from subscription block settings (only when subscription is ON)
      if (window.__btfSubscribeOn !== false) {
        const giftDataEls = document.querySelectorAll('#btf-subscription-gifts .btf-subscription-gift-data');
        giftDataEls.forEach((el) => {
          const id = el.dataset.id;
          const handle = el.dataset.handle;
          if (id && handle && !handle.includes('shipping')) {
            giftProductIds.push(id);
            giftProductHandles.push(handle);
          }
        });
      }

      // v2/v3 bundle sections: free gifts come from the SELECTED variant's
      // custom.gifts metaobject, rendered server-side as a variantId →
      // [giftVariantId,...] map (#btf-variant-gift-map). Gifts are added only in
      // subscription mode; one-time gets none. __btfSubscribeOn is not set in
      // these sections, so subscription is detected from the picker state
      // (selling_plan input / subscription toggle / pressed subscription pill row).
      (function collectVariantGifts() {
        const mapEl = document.getElementById('btf-variant-gift-map');
        if (!mapEl) return;

        const spInput = document.querySelector('.main-product-form input[name="selling_plan"]');
        const toggle = document.querySelector('[data-subscription-toggle]');
        const pillSubRow = document.querySelector('[data-bp-pill-row][data-bp-mode="subscription"][aria-pressed="true"]');
        const isSubscription =
          !!(spInput && spInput.value) ||
          (toggle && toggle.getAttribute('aria-pressed') === 'true') ||
          !!pillSubRow;
        if (!isSubscription) return;

        let giftMap;
        try {
          giftMap = JSON.parse(mapEl.textContent || '{}');
        } catch (e) {
          console.warn('[BTF] Could not parse variant gift map:', e);
          return;
        }

        const activeVariantId =
          document.getElementById('product-id')?.value ||
          document.querySelector('.bp-card.is-active')?.getAttribute('data-variant-id');
        const ids = (activeVariantId && giftMap[activeVariantId]) || [];
        ids.forEach((id) => {
          const sid = String(id);
          if (sid && giftProductIds.indexOf(sid) === -1) {
            giftProductIds.push(sid);
          }
        });
      })();

      const btn = this;

      fetch('/cart.js')
        .then((res) => res.json())
        .then((cartData) => {
          let dynamicBoxIndex = 0;
          cartData.items.forEach((item) => {
            if (item.properties && item.properties._dynamicBoxIndex !== undefined) {
              dynamicBoxIndex = Math.max(dynamicBoxIndex, +item.properties._dynamicBoxIndex + 1);
            }
          });

          const itemProperties = {};
          if (build_a_box_id) {
            itemProperties._dynamicBoxIndex = dynamicBoxIndex;
            itemProperties._dynamicBoxId = build_a_box_id;
          }
          window.__currentBoxId = build_a_box_id;
          window.__currentBoxIndex = dynamicBoxIndex;
          if (giftProductHandles.length > 0) {
            itemProperties._gift_products_handles = giftProductHandles.join(',');
          }

          let payload;

          if (window.__btfSubscribeOn === false && window.__btfSecondVariantId) {
            // ─── ONE-TIME MODE (second product) ───
            // Legacy build-a-box format: ONE line item with all colors as properties
            const legacyProperties = {};
           selectedColors.forEach((color, idx) => {
            if (color.dataset.selected === 'true' && color.dataset.id) {
              const i = idx + 1;
              const titleEl = color.querySelector('p');

              // Look up the source picker card by variant ID — it has a verified
              // (probe-loaded) image URL in data-image-added that matches the color name.
              // The selected slot's data-image-line-item points to wrong content
              // for some metaobject-sourced colors.
              const sourceCard = document.querySelector(
                `.nail-picker-color[data-id="${color.dataset.id}"]`
              );
              const lineItemImage =
                sourceCard?.dataset.imageAdded ||
                sourceCard?.dataset.imageAddedAlt ||
                sourceCard?.dataset.imageAddedCap ||
                sourceCard?.dataset.imageLineItem ||
                sourceCard?.dataset.image ||
                '';

              legacyProperties[`_${i}.`] = lineItemImage;
              const rawTitle = titleEl?.textContent || '';
              // Strip " Gel Wrap" suffix to match the cart drawer modal's color naming
              const normalizedTitle = rawTitle.replace(/\s+gel\s+wrap$/i, '').trim();
              legacyProperties[`Gel ${i}`] = normalizedTitle;
              legacyProperties[`_id${i}.`] = color.dataset.id;
            }
          });

            payload = {
              items: [
                {
                  id: window.__btfSecondVariantId,
                  quantity: 1,
                  properties: legacyProperties,
                },
              ],
            };
          } else {
            // ─── SUBSCRIPTION MODE ───
            payload = {
              items: [
                ...selectedColorIds.map((id) => ({
                  id: id,
                  quantity: 1,
                  ...(window.__btfSubscribeOn && selected_selling_plan_id && { selling_plan: selected_selling_plan_id }),
                  ...(Object.keys(itemProperties).length > 0 && { properties: itemProperties }),
                })),
              ],
            };
          }


          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
        })
        .then((res) => res.json())
        .then((responseData) => {
          btn.classList.remove('loading');
          btn.disabled = false;

          if (responseData.items) {
            const responseCheckoutFlow = document.getElementById('section-wrapper')?.dataset.checkoutFlow || 'v1';
            // Buy Buttons setting: when on, go straight to checkout instead of
            // opening the cart drawer (treated like the existing v3 redirect flow).
            const redirectToCheckout = document.getElementById('section-wrapper')?.dataset.redirectToCheckout === 'true';
            const shouldRedirect = redirectToCheckout || responseCheckoutFlow === 'v3';

            // Only flip to "Added to cart" confirmation when we stay on the page
            // (not when redirecting to checkout)
            if (!shouldRedirect) {
              const addingEl = document.getElementById('adding-to-cart-button-text');
              const addedEl = document.getElementById('added-to-cart-button-text');
              if (addingEl && addedEl) {
                playAtcFlip(addingEl, addedEl);
              }
            }
            // Cart add confirmed — update counter silently in background
            fetch(window.Shopify.routes.root + 'cart.js')
              .then((r) => r.json())
              .then((cart) => {
                document.querySelectorAll('.cart_items_counter').forEach((el) => {
                  el.textContent = cart.item_count;
                });
              });

            // Cart update in background (silent)
            if (typeof window.updateCartDrawer === 'function') {
              window.updateCartDrawer();
            } else {
              document.dispatchEvent(new CustomEvent('cart:updated'));
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }

            if (shouldRedirect) {

              if (giftProductIds.length > 0) {
                const giftPayload = {
                  items: giftProductIds.map(id => ({
                    id: parseInt(id),
                    quantity: 1,
                    properties: { '_gift': 'true' }
                  }))
                };

                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(giftPayload)
                })
                .then(() => {
                  window.location.href = '/checkout';
                })
                .catch((err) => {
                  window.location.href = '/checkout';
                });
              } else {
                window.location.href = '/checkout';
              }
              return;
            }

            // ============================================
            // NEW: v1 & v2 — add gifts as separate line items (subscription mode only)
            // ============================================
            if (giftProductIds.length > 0 && window.__btfSubscribeOn !== false) {
              const giftPayload = {
                items: giftProductIds.map(id => ({
                  id: parseInt(id),
                  quantity: 1,
                  properties: {
                    '_gift': 'true',
                    ...(window.__currentBoxId && { '_dynamicBoxId': window.__currentBoxId }),
                    ...(typeof window.__currentBoxIndex !== 'undefined' && { '_dynamicBoxIndex': String(window.__currentBoxIndex) })
                  }
                }))
              };

              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(giftPayload)
              }).then(() => {
                fetch(window.Shopify.routes.root + 'cart.js')
                  .then(r => r.json())
                  .then(cart => {
                    document.querySelectorAll('.cart_items_counter').forEach(el => {
                      el.textContent = cart.item_count;
                    });
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                  });
              }).catch(err => {
                console.warn('[Loop] Gift add failed:', err);
              });
            }

            // v1 & v2: drawer opens at 3s, picker clears 500ms after drawer opens
            setTimeout(() => {
              if (typeof window.onOpenDrawer === 'function') {
                window.onOpenDrawer();
              } else {
                const drawer = document.getElementById('byteex_cart_drawer');
                if (drawer) drawer.style.display = 'block';
              }

              setTimeout(() => {
                if (typeof window.clearNailPickerGelWraps === 'function') {
                  window.clearNailPickerGelWraps();
                }
              }, 500);
            }, 3000);

          } else {
            const failCheckoutFlow = document.getElementById('section-wrapper')?.dataset.checkoutFlow || 'v1';
            const atcElRollback = document.getElementById('atc-button-text');
            
            if (failCheckoutFlow === 'v3') {
              // v3: reverse flip from "Redirecting..." back to CONTINUE TO CHECKOUT
              const redirectingElRollback = document.getElementById('redirecting-button-text');
              if (atcElRollback && redirectingElRollback) {
                atcElRollback.innerHTML = '<span>CONTINUE TO CHECKOUT</span>';
                playAtcFlipReverse(redirectingElRollback, atcElRollback);
              }
            } else {
              const addingElRollback = document.getElementById('adding-to-cart-button-text');
              if (atcElRollback && addingElRollback) {
                playAtcFlipReverse(addingElRollback, atcElRollback);
              }
            }

            const errorMsg = responseData.message || responseData.description || 'Unknown error';
            console.error('[Loop] Cart add failed:', errorMsg, responseData);
            alert('Could not add items: ' + errorMsg);
          }
        })
        .catch((err) => {
          console.error('[Loop] Cart error:', err);
          btn.classList.remove('loading');
          btn.disabled = false;

          const catchCheckoutFlow = document.getElementById('section-wrapper')?.dataset.checkoutFlow || 'v1';
          const atcElRollback = document.getElementById('atc-button-text');
          
          if (catchCheckoutFlow === 'v3') {
            const redirectingElRollback = document.getElementById('redirecting-button-text');
            if (atcElRollback && redirectingElRollback) {
              atcElRollback.innerHTML = '<span>CONTINUE TO CHECKOUT</span>';
              playAtcFlipReverse(redirectingElRollback, atcElRollback);
            }
          } else {
            const addingElRollback = document.getElementById('adding-to-cart-button-text');
            if (atcElRollback && addingElRollback) {
              playAtcFlipReverse(addingElRollback, atcElRollback);
            }
          }

          alert('There was an issue adding your items. Please try again.');
        });

    }, true);
  }

  // ─────────────────────────────────────────────
  // 2. INITIALISE FROM NATIVE SELLING PLANS (Loop)
  //    Loop registers native Shopify selling plans on the product;
  //    Liquid renders them into #variant-picker-data. No external
  //    subscription-app API call is made (Skio dynamic-box fetch removed).
  // ─────────────────────────────────────────────
  useLiquidFallback();
})();
});